import { useCreate } from '../../../../../../api/react-query';

export const useUpdateEnrollFace = () => {
  const { mutateAsync: updateFaceEnroll, isLoading: isUpdating } = useCreate({
    url: 'employees/enroll-face',
  });

  return {
    updateFaceEnroll,
    isUpdating,
  };
};
